// extracted by mini-css-extract-plugin
export default {"detailsSubHeader":"src-client-components-SapiSubscriptionModule-components-SubscriptionDetails-DetailsSubHeader-styles-___default__detailsSubHeader___N+6ox"};